

































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import TextDayChangePicker from "./TextDayChangePicker.vue";

@Component({
  components: {
    TextDayChangePicker
  }
})
export default class DayPickerDialog extends Vue {
  @Prop({ default: "【タイトル】" }) title!: string;
  @Prop({ default: "" }) description!: string;
  @Prop({ default: "対象年月日" }) dayLabel!: string;
  @Prop({ default: "OK" }) buttonOk!: string;
  @Prop({ default: "キャンセル" }) buttonCancel!: string;
  @Prop({ default: false }) isActive!: boolean;

  //リアルタイム今日
  private today(): string {
    const date = new Date();
    date.setTime(date.getTime() + 1000 * 60 * 60 * 9); //日本時間にする
    const today = date.toISOString().substr(0, 10);
    return today;
  }

  //出力タイプ
  private innerToday = this.today();

  //決定
  @Emit()
  private selected() {
    return this.innerToday;
  }

  //キャンセル
  @Emit()
  private cancel() {
    return;
  }
}
